import React from 'react';
import { connect } from 'react-redux';
import Logger, { LOG_LEVELS } from '../../utils/logger';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import ReactTable from "react-table";
//import ExistingLegalEntitiesData from './fallbackData/ExistingLegalEntitiesData.json';
//import LegalEntityForm from './LegalEntityForm';
import LIVE_REPORTING_CONTROLLER from '../../controllers/liveReporting';
import NoData from '../page/NoData';
import Pagination from '../page/Pagination'

const log = new Logger('EXISTING_LEGAL_ENTITIES', LOG_LEVELS.DEBUG);

export class ExistingLegalEntities extends React.Component {

  constructor(props) {
    super(props);
     this.onDeleteClick = this.onDeleteClick.bind(this);
  }

  onDeleteClick(cellInfo) {
    if (window.confirm('Are you sure you wish to delete this item?')) {
      const taxNumber = cellInfo.TaxNumber;
      this.props.doDeleteLegalEntity(taxNumber, this.props.onCellDeleteDone);
    }
  }

  render() {
    const columns = [{
      Header: props => <span><LanguageStringResolver string="liveReportingSetup_TaxNumber"></LanguageStringResolver></span>,
      accessor: 'TaxNumber',
      filterable: true
    }, {
      Header: props => <span><LanguageStringResolver string="liveReportingSetup_SupplierName"></LanguageStringResolver></span>,
      accessor: 'SellerName',
      filterable: true
    }, {
      Header: props => <span><LanguageStringResolver string="liveReportingSetup_Login"></LanguageStringResolver></span>,
      accessor: 'Login',
      filterable: true
    }, {
      id: "checkbox",
      accessor: "SendingEnabled",
      Cell: ({ original }) => {
        return (
          <a className="tertiary" onClick={(e) => { this.onDeleteClick(original); }}>
            <LanguageStringResolver string='liveReportingSetup_Delete'/>
          </a>
        );
      },
      Header: props => <span><LanguageStringResolver string='liveReportingSetup_Delete'/></span>,
      className: 'text-align-center',
      sortable: false
    }]
    log.debug('render(): ', this.props);

    const NoDataComponent = props => (
      <NoData
        noDataText="liveReportingSetup_NoData"
        {...props}
      />
    )

    return (
      <ReactTable
        defaultPageSize={20}
        minRows={0}
        maxRows={0}
        data={this.props.data}
        columns={columns}
        NoDataComponent={NoDataComponent}
        className={this.props.data.length === 0 ? 'hide-header' : ''}
        PaginationComponent={Pagination}
        showPagination={this.props.data.length === 0 ? false : true}
      />
    )
  }
}

function mapStateToProps(state) {
  log.debug('mapStateToProps: ', state);
  return {
    languages: state.languages
  };
}

function mapDispatchersToProps(dispatch) {
  return {
    doUpdateLegalEntity: (taxNumber, params, done) => {
      log.debug('doUpdateLegalEntity: ', params);
      dispatch(LIVE_REPORTING_CONTROLLER.doUpdateLegalEntity(taxNumber, params, done));
    },
    doDeleteLegalEntity: (taxNumber, done) => {
      log.debug('doDeleteLegalEntity: ', taxNumber);
      dispatch(LIVE_REPORTING_CONTROLLER.doDeleteLegalEntity(taxNumber, done));
    }
  }
}


ExistingLegalEntities.defaultProps = {
  data: [],
  onCellEditDone: () => { },
  onCellDeleteDone: () => { }
};

export default connect(mapStateToProps, mapDispatchersToProps)(ExistingLegalEntities);
